const URA_HOST_MAP = "https://maps.ura.gov.sg";
const ONEMAP_HOST_MAP = "https://www.onemap.gov.sg";

const BASEMAPS = {

  ONEMAP: {
      icon: "https://s3.ap-southeast-1.amazonaws.com/cloud.rocksolid.sg/me/images/amenities/OneMap.png",
      //
      id: "onemap",
      name: "OneMap",/** DO NOT REMOVE the OneMap attribution below **/
   		attribution: '<img src="https://www.onemap.gov.sg/web-assets/images/logo/om_logo.png" style="height:20px;width:20px;vertical-align:bottom;"/>&nbsp;<a href="https://www.onemap.gov.sg/" target="_blank" rel="noopener noreferrer">OneMap</a>&nbsp;&copy;&nbsp;contributors&nbsp;&#124;&nbsp;<a href="https://www.sla.gov.sg/" target="_blank" rel="noopener noreferrer">SLA</a>',
      url: ONEMAP_HOST_MAP + "/maps/tiles/Default/{z}/{x}/{y}.png",
      esriLayer: !1,
      pane: "bm_om",
      minZoom: 11,
      maxZoom: 19,
      paneZIndex: 201,
			visible: !0,
      opacity: 100,
      showInLayer: !0
  },
  MASTERPLAN_2025: {
      icon: "https://s3.ap-southeast-1.amazonaws.com/cloud.rocksolid.sg/me/images/amenities/URA.png",
      //
      id: "mp2025",
      name: "Draft Master Plan 2025",
      attribution: "",
      url: URA_HOST_MAP + "/arcgis/rest/services/DMP25/DMP25_Landuse/MapServer",
      esriLayer: !0,
      pane: "bm_mp25",
      minZoom: 11,
      maxZoom: 17,
      paneZIndex: 202,
      visible: !1,
      opacity: 100,
      showInLayer: !0
  },
  MASTERPLAN_AMD: {
      icon: "https://s3.ap-southeast-1.amazonaws.com/cloud.rocksolid.sg/me/images/amenities/URA.png",
      //
      id: "mp2019",
      name: "Master Plan 2019 Approved Amendments",
      attribution: "",
      url: URA_HOST_MAP + "/arcgis/rest/services/MP19/Updated_Landuse_gaz/MapServer",
      esriLayer: !0,
      pane: "bm_mp19a",
      minZoom: 11,
      maxZoom: 17,
      paneZIndex: 202,
      visible: !1,
      opacity: 100,
      showInLayer: !0
  },
	MASTERPLAN_2014: {
      icon: "https://s3.ap-southeast-1.amazonaws.com/cloud.rocksolid.sg/me/images/amenities/URA.png",
      //
			id: "mp2014",
			name: "Master Plan 2014",
			url: URA_HOST_MAP + "/arcgis/rest/services/maps2/MP14_Land_Use_gaz_maps/MapServer",
			esriLayer: !0,
			pane: "bm_mp14",
			minZoom: 0,
			maxZoom: 17,
			paneZIndex: 204,
			visible: !1,
			opacity: 100,
			showInLayer: !1
	},
	MASTERPLAN_2008: {
      icon: "https://s3.ap-southeast-1.amazonaws.com/cloud.rocksolid.sg/me/images/amenities/URA.png",
      //
			id: "mp2008",
			name: "Master Plan 2008",
			url: URA_HOST_MAP + "/arcgis/rest/services/maps2/MP2008/MapServer/tile/{z}/{y}/{x}",
			esriLayer: !0,
			pane: "bm_mp08",
			minZoom: 0,
			maxZoom: 17,
			paneZIndex: 205,
			visible: !1,
			opacity: 100,
			showInLayer: !1
	},
	MASTERPLAN_2003: {
      icon: "https://s3.ap-southeast-1.amazonaws.com/cloud.rocksolid.sg/me/images/amenities/URA.png",
      //
			id: "mp2003",
			name: "Master Plan 2003",
			url: URA_HOST_MAP + "/arcgis/rest/services/maps2/MP2003_raster/MapServer/tile/{z}/{y}/{x}",
			esriLayer: !0,
			pane: "bm_mp03",
			minZoom: 0,
			maxZoom: 17,
			paneZIndex: 206,
			visible: !1,
			opacity: 100,
			showInLayer: !1
	},
	LANDLOT: {
      icon: "https://s3.ap-southeast-1.amazonaws.com/cloud.rocksolid.sg/me/images/amenities/SLA.png",
      //
			id: "landlot",
			name: "Land Lot",
			url: ONEMAP_HOST_MAP + "/maps/tiles/LandLot/{z}/{x}/{y}.png",
			esriLayer: !1,
			pane: "bm_ll",
			minZoom: 0,
			maxZoom: 18,
			paneZIndex: 210,
			visible: !1,
			opacity: 100,
			showInLayer: !0,
			continuousWorld: !0
	},
  LANDED_HOUSING: {
      icon: "https://s3.ap-southeast-1.amazonaws.com/cloud.rocksolid.sg/me/images/amenities/URA.png",
      //
      id: "ol18",
      name: "Landed Housing Area",
      url: URA_HOST_MAP + "/arcgis/rest/services/MP19/Landed_Housing/MapServer",
      esriLayer: !0,
      featureType: "dynamic",
      paneZIndex: 414,
      layers: [],
      visible: !1,
      opacity: 100,
      showInLayer: !1
  },

}

const LEAFLET_LAYER_ICON = "https://unpkg.com/leaflet@1.9.4/dist/images/layers.png";
const BASEMAPS_ENTRIES = Object.entries(BASEMAPS).map(([_, config]) => config);

export { BASEMAPS, BASEMAPS_ENTRIES, LEAFLET_LAYER_ICON };
